import {PERIOD_ANNUALLY, PERIOD_ANNUALLY_MONTHLY_PAID, PERIOD_MONTHLY} from "../Constants";
import PlanVariantButton from "./PlanVariantButton";
import PaymentVariantButton from "./PaymentVariantButton";
import {useContext} from "react";
import {StateContext} from "../Contexts";
import {getPlanVariantForPeriod} from "../Billwerk/SubscriptionJS";

export default function () {
    /** @type CheckoutState */
    const state = useContext(StateContext);

    let monthlyPlanVariant = getPlanVariantForPeriod(state, PERIOD_MONTHLY);
    let twoColumnMode = state.productInfo && monthlyPlanVariant && state.mainProps.monthlyPeriod !== 'hidden';

    return <div className="grid grid-cols-1 gap-6">
        {state.mainProps.variantLocked === null && twoColumnMode &&
            <p className="text-xl text-center xl:text-left text-blue-dark font-medium leading-[1.375rem]">Vertragslaufzeit auswählen</p>
        }
        <div className={`grid grid-cols-1 gap-6` + (twoColumnMode ? ' xl:grid-cols-2 xl:gap-12' : '')}>
            <PlanVariantButton period={state.paymentProviderChangeModeEnabled ? PERIOD_ANNUALLY : PERIOD_ANNUALLY_MONTHLY_PAID}
                               periodLabel="Jährlich"
                               active={state.period === PERIOD_ANNUALLY || state.period === PERIOD_ANNUALLY_MONTHLY_PAID}
                               twoColumnMode={twoColumnMode}></PlanVariantButton>
            {state.mainProps.monthlyPeriod !== 'hidden' &&
                <PlanVariantButton period={PERIOD_MONTHLY}
                                   periodLabel="Monatlich"
                                   active={state.period === PERIOD_MONTHLY}
                                   twoColumnMode={twoColumnMode}
                    {...(state.mainProps.monthlyPeriod === 'disabled' ? {disabled: true} : {})}></PlanVariantButton>
            }
        </div>
        {!state.paymentProviderChangeModeEnabled && getPlanVariantForPeriod(state, PERIOD_ANNUALLY_MONTHLY_PAID) &&
            <PaymentVariantButton disabled={state.period !== PERIOD_ANNUALLY && state.period !== PERIOD_ANNUALLY_MONTHLY_PAID}></PaymentVariantButton>
        }
    </div>
}
